import Dashboard from './../components/templates/Dashboard.vue'
import Show from './../components/templates/Show.vue'
import Create from './../components/templates/Create.vue'
import Edit from './../components/templates/Edit.vue'
import Root from './../components/Root.vue'
export default {
  path: 'templates',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.templates.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.templates.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.templates.create',
      component: Create
    },
    {
      path: ':id/update',
      name: 'admin.templates.edit',
      component: Edit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/templates.js